// create and cache a router instance
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const router = new VueRouter({
   mode: 'history'
});

export default router